const baseUrl = "/v1/admin/talukas";

export const API_URL = {
  LIST: `${baseUrl}`,
  CREATE: `${baseUrl}/create`,
  UPDATE: (id: number): string => `${baseUrl}/${id}/update`,
  DELETE: (id: number): string => `${baseUrl}/${id}/delete`,
  DETAILS: (id: number): string => `${baseUrl}/${id}/details`,
  CHANGE_STATUS: (id: number): string => `${baseUrl}/${id}/change-status`,
  TALUKA_LIST: (search?: string): string =>
    `/v1/admin/talukas/lov${search ? `?pincode_id=${search}` : ""}`,
};